import React, { useCallback } from 'react'
import { fade, makeStyles, IconButton, Typography } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import useLogEventToAll from 'utils/useLogEventToAll'
import { LEGACY_SEARCH_CLICKED } from 'amplitude/events'

import navigate from 'utils/navigate'
import { colors } from 'theme'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    height: 56,
    minWidth: 330,
    outline: 'none',
    border: 'none',
    padding: theme.spacing(1, 0, 1, 1.5),
    marginRight: theme.spacing(1),
    backgroundColor: fade(colors.background, 0.06),
    color: fade(colors.white, 0.38),
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'text',
    borderRadius: '4px 4px 0 0',
    transition: 'background-color 0.15s',

    '&:hover': {
      backgroundColor: fade(colors.background, 0.13),
    },
  },

  icon: {
    color: colors.white,
    padding: theme.spacing(1),
  },
}))

const SearchField = () => {
  const classes = useStyles()
  const logEvent = useLogEventToAll()

  const handleClick = useCallback(
    event => {
      logEvent(LEGACY_SEARCH_CLICKED, { url: window.location.href })
      navigate('/search')
      event.stopPropagation()
    },
    [logEvent],
  )

  return (
    <button type="button" className={classes.container} onClick={handleClick}>
      <Typography component="span">Type a title, author, or poet...</Typography>

      <IconButton
        className={classes.icon}
        role="button"
        onClick={handleClick}
        aria-label="search"
      >
        <SearchIcon color="inherit" />
      </IconButton>
    </button>
  )
}

export default SearchField
